import React, { useState } from "react";
import styles from "./AccountManagement.module.css";

const AccountManagement = () => {
  const [viewReports, setViewReports] = useState(true);
  const [extraExpenses, setExtraExpenses] = useState(true);
  const [monitorDues, setMonitorDues] = useState(true);
  const [customerDues, setCustomerDues] = useState(1200); // Example total dues
  const [supplierDues, setSupplierDues] = useState(800); // Example total dues
  const [transactionFilter, setTransactionFilter] = useState("daily");

  const handleTransactionFilterChange = (event) => {
    setTransactionFilter(event.target.value);
  };

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>Accounting Management Dashboard</h2>
<div className="d-flex">

      {/* Financial Reports Section */}
      <div className={styles.section}>
        <h3>Financial Reports</h3>
        <div className={styles.toggleSection}>
          <label>View Profit/Loss Statement:</label>
          <input
            type="checkbox"
            checked={viewReports}
            onChange={() => setViewReports(!viewReports)}
          />
        </div>
        {viewReports && (
          <div className={styles.subSection}>
            <div className={styles.chart}>
              <label>Daily Profit/Loss:</label>
              <div className={styles.progressBar}>
                <div
                  className={styles.progress}
                  style={{ width: "75%", backgroundColor: "#4caf50" }}
                ></div>
              </div>
              <span>75% Goal Achieved</span>
            </div>
            <div className={styles.chart}>
              <label>Weekly Profit/Loss:</label>
              <div className={styles.progressBar}>
                <div
                  className={styles.progress}
                  style={{ width: "50%", backgroundColor: "#ff9800" }}
                ></div>
              </div>
              <span>50% Goal Achieved</span>
            </div>
            <div className={styles.chart}>
              <label>Monthly Profit/Loss:</label>
              <div className={styles.progressBar}>
                <div
                  className={styles.progress}
                  style={{ width: "90%", backgroundColor: "#2196f3" }}
                ></div>
              </div>
              <span>90% Goal Achieved</span>
            </div>
          </div>
        )}
      </div>

      {/* Extra Expenses Section */}
      <div className={styles.section}>
        <h3>Extra Expenses</h3> 
        <button>View expenses</button>
        <div className={styles.toggleSection}>
          <label>Log Extra Expenses (Utilities, Maintenance, etc.):</label>
          {/* <input
            type="checkbox"
            checked={extraExpenses}
            onChange={() => setExtraExpenses(!extraExpenses)}
          /> */}
        </div>
      
          <div className={styles.subSection}>
            <div>
              <label>Expense Description:</label>
              <input type="text" className={styles.inputField} />
            </div>
            <div>
              <label>Amount:</label>
              <input type="number" className={styles.inputField} />
            </div>
            <div>
              <label>Date of Expense:</label>
              <input type="date" className={styles.inputField} />
            </div>
            <button>SAVE</button>
          </div>
      
      </div>
      {/* Pending Dues Section */}
      <div className={styles.section}>
        <h3>Pending Dues</h3>
        <div className={styles.toggleSection}>
          <label>Monitor Pending Payments (Customers & Suppliers):</label>
          <input
            type="checkbox"
            checked={monitorDues}
            onChange={() => setMonitorDues(!monitorDues)}
          />
        </div>
        {monitorDues && (
          <div className={styles.subSection}>
            <div>
              <h4>Total Customer Dues: RS {customerDues}</h4>
              <button>View customer due</button>
            </div>
            <div>
              <h4>Total Supplier Credit: RS {supplierDues}</h4>
              <button>View Supplier due</button>
            </div>
           
          </div>
        )}
      </div>
</div>



      {/* View Transactions Section */}
      <div className={styles.section}>
        <h3>View Transactions</h3>
        <div className={styles.subSection}>
          <label>Filter Transactions By:</label>
          <select
            value={transactionFilter}
            onChange={handleTransactionFilterChange}
            className={styles.inputField}
          >
            <option value="daily">Daily</option>
            <option value="weekly">Weekly</option>
            <option value="monthly">Monthly</option>
            <option value="yearly">Yearly</option>
          </select>
          <div className={styles.transactionList}>
            <p>Displaying {transactionFilter} transactions...</p>
            {/* Dynamic transaction data will go here */}
          </div>
        </div>
      </div>


    </div>
  );
};

export default AccountManagement;
